import { Store } from 'pullstate';

export const DataStore = new Store({
    // selectedQROutletId: '',
    navigationObj: null,

    linkToFunc: null,

    upsellingCampaignsAfterCart: [],
    upsellingCampaignsAfterCheckout: [],
    upsellingCampaignsAfterCheckoutRecommendation: [],

    // upsellingCampaignsReservation: [],
});
